import { buildStorage } from "@stepapp/core";

type Keys = {
  booleanKeys: [
    "cookiesConsent",
    "hasOpenedApp",
    "sawChangelog",
    "sawNotifications",
    "afterWalkthrough",
  ];
  numberKeys: ["visitsAfterReservation"];
  stringKeys: [
    "appRateDate",
    "deviceFingerprint",
    "countryCode",
    "refreshExpiresIn",
    "refreshToken",
    "token",
    "tokenExpiresIn",
  ];
};

const storage = {
  encryptionKey: "customer",
  id: "stepapp@customer",
  booleanKeys: [
    "cookiesConsent",
    "hasOpenedApp",
    "sawChangelog",
    "sawNotifications",
    "afterWalkthrough",
  ],
  numberKeys: ["visitsAfterReservation"],
  stringKeys: [
    "appRateDate",
    "deviceFingerprint",
    "countryCode",
    "refreshExpiresIn",
    "refreshToken",
    "token",
    "tokenExpiresIn",
  ],
};

let initializedStorage: ReturnType<typeof buildStorage<Keys>>;

export const AppStorage = () => {
  if (initializedStorage) return initializedStorage;

  const appStorage = buildStorage<Keys>(storage);
  initializedStorage = appStorage;
  return appStorage;
};
